/** @jsxImportSource @emotion/react */
import React from 'react'
import { Alert } from 'antd'
import { Link } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import { css } from '@emotion/react'
import { paragraphSmall } from 'src/components/css'

interface PreviewBannerProps {
  id: string
}

/**
 * Preview banner component that displays an info alert to indicate preview mode
 * and provides a link to the live registration page
 * @param id - The registration ID used to generate the live registration link
 */
const PreviewBanner: React.FC<PreviewBannerProps> = ({ id }) => {
  console.log(
    '🔄 PreviewBanner: rendering preview banner with registration ID',
    id
  )

  return (
    <Alert
      type='info'
      banner
      showIcon
      message="You're Viewing a Preview"
      description={
        <span
          css={css`
            ${paragraphSmall}
            color: ${colors.NEUTRAL_50};
          `}
        >
          If you want to see the live registration,&nbsp;
          <Link
            to={ROUTES.REGISTRATION_INVITE.replace(':id', id)}
            css={css`
              ${paragraphSmall}
              color: ${colors.PRIMARY};
              &:hover {
                opacity: 0.8;
              }
            `}
          >
            click here
          </Link>
          .
        </span>
      }
      css={{
        position: 'fixed',
        top: 56,
        left: 24,
        zIndex: 1000,
        maxWidth: 320,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: 8,
      }}
    />
  )
}

export default PreviewBanner
